export default {
  list: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes/endorsement`,
  },
  partners: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/insurances`,
  },
  detail: {
    method: "get",
    url: "/api/flight/v2/policies/:number",
  },
  products: {
    method: "get",
    url: "",
  },
  productCategories: {
    method: "get",
    url: "",
  },
  export: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes/endorsement/action/download`,
  },
  generateS3PresignUrl: {
    method: "post",
    url: "/api/flight/v2/documents",
  },
};
